
import { Link } from "react-router-dom";
import { ShoppingCart, User, LogOut, History, Package } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { useUserRole } from "@/hooks/useUserRole";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const NavBar = () => {
  console.log("NavBar: Rendering navigation component");
  
  const { user, signOut } = useAuth();
  const { items } = useCart();
  const { isAdmin } = useUserRole();

  const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);
  
  console.log("NavBar: User status:", user ? "logged in" : "not logged in");
  console.log("NavBar: Cart items count:", itemCount);
  console.log("NavBar: User is admin:", isAdmin);

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
      <div className="container mx-auto px-4 h-16 flex items-center">
        <div className="flex-1 flex items-center justify-start">
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <img 
              src="/lovable-uploads/c7ab57c0-ad06-4bfe-ba49-7a038974d7c5.png" 
              alt="Agro" 
              className="h-8"
            />
          </Link>
        </div>

        <nav className="flex-1 hidden md:flex items-center justify-center gap-6">
          <Link 
            to="/" 
            className="text-sm font-medium hover:text-primary transition-colors"
          >
            Produits
          </Link>
          <Link 
            to="/cart" 
            className="text-sm font-medium hover:text-primary transition-colors"
          >
            Panier
          </Link>
          {user && (
            <>
              <Link 
                to="/account" 
                className="text-sm font-medium hover:text-primary transition-colors"
              >
                Mon compte
              </Link>
              <Link 
                to="/order-history" 
                className="text-sm font-medium hover:text-primary transition-colors"
              >
                Mes commandes
              </Link>
            </>
          )}
        </nav>

        <div className="flex-1 flex items-center justify-end gap-6">
          <Link 
            to="/cart" 
            className="relative p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ShoppingCart className="h-5 w-5" />
            {itemCount > 0 && (
              <Badge 
                className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center p-0 bg-primary text-primary-foreground"
                variant="secondary"
              >
                {itemCount}
              </Badge>
            )}
          </Link>

          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button 
                  variant="ghost"
                  size="icon"
                  className="rounded-full hover:bg-gray-100"
                >
                  <User className="h-5 w-5" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent 
                align="end" 
                className="w-56 bg-white border border-gray-200 shadow-lg rounded-lg mt-2"
              >
                <div className="px-4 py-3 border-b border-gray-100">
                  <p className="text-sm font-medium text-gray-900">Mon compte</p>
                  <p className="text-xs text-gray-500 mt-1">{user.email}</p>
                </div>
                <DropdownMenuItem asChild className="focus:bg-gray-50">
                  <Link to="/account" className="w-full cursor-pointer px-4 py-2">
                    Paramètres du compte
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuItem asChild className="focus:bg-gray-50">
                  <Link to="/order-history" className="w-full cursor-pointer px-4 py-2">
                    <History className="h-4 w-4 mr-2" />
                    Historique des commandes
                  </Link>
                </DropdownMenuItem>
                {isAdmin && (
                  <>
                    <DropdownMenuSeparator className="bg-gray-100" />
                    <DropdownMenuItem asChild className="focus:bg-gray-50">
                      <Link to="/admin/orders" className="w-full cursor-pointer px-4 py-2">
                        Administration des commandes
                      </Link>
                    </DropdownMenuItem>
                    <DropdownMenuItem asChild className="focus:bg-gray-50">
                      <Link to="/admin/products" className="w-full cursor-pointer px-4 py-2">
                        <Package className="h-4 w-4 mr-2" />
                        Gestion des produits
                      </Link>
                    </DropdownMenuItem>
                  </>
                )}
                <DropdownMenuSeparator className="bg-gray-100" />
                <DropdownMenuItem 
                  className="text-red-600 cursor-pointer focus:bg-red-50 focus:text-red-700 px-4 py-2"
                  onClick={signOut}
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Se déconnecter
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <Link to="/account">
              <Button variant="secondary" size="sm">
                Connexion
              </Button>
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
